import { CRLF } from "../constants/newlines";

const buildSegment = ({ contentType, value }) => [
    `Content-Type: ${contentType}`,
    'Content-Transfer-Encoding: binary',
    '',
    value,
    '',
    '',
].join(CRLF);

// ([{ contentType: string, value: string }], String) -> { contentType: String, body: String }
const buildMultipartRequest = (parts, boundary) => {
    const separator = '--' + boundary + CRLF;
    const segments = parts.map(buildSegment);

    return {
        contentType: `multipart/mixed; boundary=${boundary}`,
        body: ['', ...segments].join(separator) + '--' + boundary + '--' + CRLF,
    }
}

export default buildMultipartRequest;